module.exports = __webpack_public_path__ + "img/head.32a5e387.png";